import {
  ADD_NOTIFICATIONS,
  REMOVE_NOTIFICATIONS,
} from "../actions/notifications";

const initialState = [];

const user = (state = initialState, action) => {
  switch (action.type) {
    case ADD_NOTIFICATIONS:
      return [
        ...state.filter(({ key }) => key !== action.payload?.key),
        action.payload,
      ];
    case REMOVE_NOTIFICATIONS:
      return state.filter(({ key }) => !action.payload.includes(key));
    default:
      return state;
  }
};

export default user;
